module.exports = __webpack_public_path__ + "media/images/programs/header-6831a7b8ed5df3bf46fcbf079d23c1c6.jpg";